import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import InfoTooltip from '../../../InfoTooltip/InfoTooltip';
import styles from '../Messages.module.scss';

const EditorialRightsMessage = () => {
  const t = useTranslations();

  const renderTooltipContent = () => (
    <span
      className={styles.tooltipContent}
      data-testid="tooltip-content"
    >
      <div className={styles.tooltipTitle}>{t('common_uses_include')}</div>
      <div className={styles.tooltipDescription}>{t('common_uses')}</div>
      <div className={styles.tooltipTitle}>{t('cannot_be_used_for')}</div>
      <div className={styles.tooltipDescription}>{t('forbidden_uses')}</div>
      <div className={styles.tooltipTitle}>
        {t('esl_standard_editorial_rights')}
      </div>
      <div className={styles.tooltipDescription}>{t('standard_rights')}</div>
      <div className={styles.tooltipBottomSection}>
        {t('subject_to_content_license_agreement')}
      </div>
    </span>
  );

  return (
    <div
      className={styles.buyCardMessage}
      data-testid="editorial-rights-message"
    >
      {t('how_can_i_use_this_image')}
      <InfoTooltip
        placement="bottom-right"
        content={renderTooltipContent()}
      />
    </div>
  );
};

export default EditorialRightsMessage;
